import React from "react";
import { connect } from "react-redux";
import i18n from "i18next";
import { regenerateSuggestionsThunk } from "../../../../../common/actions";
import "./EmptyState.scss";

function EmptyState({ trainingId, sceneId, sceneTitle, canGenerateScene, onGenerate }) {
  return (
    <div className="suggestions-empty-state">
      <div className="suggestions-empty-state__inner">
        <i className="material-icons suggestions-empty-state__icon">star</i>
        <div className="suggestions-empty-state__title">
          {i18n.t("Workflow.no_suggestions_yet", {
            defaultValue: "No suggestions yet for this training",
          })}
        </div>
        <p className="suggestions-empty-state__body">
          {i18n.t("Workflow.suggestions_explainer", {
            defaultValue:
              "AI can scan your scenes and suggest where adding interactivity would deepen learning.",
          })}
        </p>
        <div className="suggestions-empty-state__actions">
          <button
            type="button"
            className="btn"
            style={{ background: "#a963f5", color: "#fff" }}
            disabled={!canGenerateScene}
            title={
              canGenerateScene
                ? ""
                : i18n.t("Workflow.scene_has_no_content", {
                    defaultValue: "This scene has no content yet",
                  })
            }
            onClick={() => onGenerate(trainingId, "scene", sceneId)}
          >
            {i18n.t("Workflow.generate_for_scene", { defaultValue: "Generate for" })} "{sceneTitle}"
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => onGenerate(trainingId, "course")}
          >
            {i18n.t("Workflow.generate_for_course", {
              defaultValue: "For the whole course",
            })}
          </button>
        </div>
        <div className="suggestions-empty-state__hint">
          {i18n.t("Workflow.suggestions_hint", {
            defaultValue:
              "Per-scene is best when iterating; whole-course is a once-per-training baseline.",
          })}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const present = (state.undoGroup && state.undoGroup.present) || {};
  const sceneId = present.navItemSelected;
  const scene = sceneId && (present.navItemsById || {})[sceneId];
  const viewToolbar = sceneId && (present.viewToolbarsById || {})[sceneId];
  // Scene titles live in viewToolbarsById[sceneId].viewName; navItem.title rarely set.
  const sceneTitle =
    (viewToolbar && viewToolbar.viewName) || (scene && scene.title) || sceneId || "—";
  const hasContent = !!(
    scene &&
    scene.boxes &&
    scene.boxes.some((bId) => (present.boxesById || {})[bId])
  );
  return {
    sceneId,
    sceneTitle,
    canGenerateScene: hasContent,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onGenerate: (trainingId, scope, sceneId) =>
    dispatch(regenerateSuggestionsThunk(trainingId, scope, sceneId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmptyState);
